import { type AppState } from 'src/redux/app/app.store'

export const selectTaskBulkDropList = (state: AppState) => state.activeTasks.bulkDropList
export const selectTasks = (state: AppState) => state.activeTasks.tasks
export const selectTaskTypes = (state: AppState) => state.activeTasks.taskTypes
